// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export var ERoomCount = /*#__PURE__*/function (ERoomCount) {
  /** Койко-место **/
  ERoomCount["Bed"] = "bed";
  /** Пятикомнатная квартира **/
  ERoomCount["FiveRoom"] = "fiveRoom";
  /** Четырехкомнатная квартира **/
  ERoomCount["FourRoom"] = "fourRoom";
  /** Многокомнатная квартира (6 и более комнат) **/
  ERoomCount["Large"] = "large";
  /** Однокомнатная квартира **/
  ERoomCount["OneRoom"] = "oneRoom";
  /** Квартира со свободной планировкой **/
  ERoomCount["OpenPlan"] = "openPlan";
  /** Комната **/
  ERoomCount["Room"] = "room";
  /** Доля в квартире **/
  ERoomCount["Share"] = "share";
  /** Студия **/
  ERoomCount["Studio"] = "studio";
  /** Трехкомнатная квартира **/
  ERoomCount["ThreeRoom"] = "threeRoom";
  /** Двухкомнатная квартира **/
  ERoomCount["TwoRoom"] = "twoRoom";
  return ERoomCount;
}({});